import request from "../../../axios";
import { PostSponsorPayload } from "./type";


export const postSponsor = async (payload: PostSponsorPayload) => {
    const { data }: { data: { ipg_url: string } } = await request.post('/api/v2/notification/payment-sponsors',
        payload
    )
    return data
}